import { render, staticRenderFns } from "./routes.vue?vue&type=template&id=0b1ef292"
import script from "./routes.vue?vue&type=script&lang=js"
export * from "./routes.vue?vue&type=script&lang=js"
import style0 from "./routes.vue?vue&type=style&index=0&id=0b1ef292&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports